import Vue from 'vue'
import VueRouter, { Route } from 'vue-router'

import ExploreDetail from '@/components/explore/ExploreDetail.vue'
import ProjectExplore from '@/components/explore/ProjectExplore.vue'

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/project/:projectSlug',
      name: 'project-detail',
      component: ExploreDetail,
    },
    {
      path: '/project/:projectSlug/voting/:votingSlug',
      name: 'project-detail-voting',
      component: ExploreDetail,
    },
    {
      path: '/:slug/',
      name: 'explore-projects',
      component: ProjectExplore,
    },
    {
      path: '/',
      name: 'explore-projects',
      component: ProjectExplore,
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0, behavior: 'smooth' }
  },
})

let initialLoad: { route: Route; pageTitle: string } = null

router.afterEach((to) => {
  delete to.query?.cashinModal // interferes with old JS code
  if (!initialLoad) {
    initialLoad = { route: to, pageTitle: document.title }
  }

  Vue.nextTick(() => {
    if (to.meta?.title) {
      document.title = to.meta.title
    } else if (initialLoad?.route.name === to.name) {
      document.title = initialLoad.pageTitle
    }
  })
})

export default router
